var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-admin-estates-item-info-document"},[_c('ui-form',{attrs:{"model":_vm.selectedFields,"submit-handler":_vm.submitHandler,"validation":_vm.validation,"gap":"wide"},on:{"update":_vm.updateFormData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }